const orgSourceOptions = [
  { label: 'Manual', value: 'Manual' },
  { label: 'Referral', value: 'Referral' },
  { label: 'Import', value: 'Import' },
  { label: 'API', value: 'API' },
  { label: 'Other', value: 'Other' },
];

export default orgSourceOptions;
